// extracted by mini-css-extract-plugin
module.exports = {"option":"OptionSelect_option__xSIcQ","desabilitar":"OptionSelect_desabilitar__3eEg1","focado":"OptionSelect_focado__33poO","novo":"OptionSelect_novo__3k1m4"};